import { Phone, MapPin, Clock, Siren, FileUp } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { PHONE, PHONE_HREF } from "../lib/scroll";

const INFO = [
  { icon: Phone, label: "Phone", value: PHONE, href: PHONE_HREF, id: "contact-phone" },
  { icon: MapPin, label: "Address", value: "19 Sarrazin Way, Nepean, Ottawa, ON K2J 4A5", id: "contact-address" },
  { icon: Clock, label: "Hours", value: "Monday – Friday, 9:00 AM – 5:00 PM\nSaturday – Sunday: Closed", id: "contact-hours" },
];

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="relative bg-[#0B0C10] py-24 sm:py-32 overflow-hidden">
    <div className="absolute -top-40 -right-40 h-[520px] w-[520px] rounded-full bg-[#FF6B00]/10 blur-[120px]" />
    <div className="relative mx-auto max-w-[1440px] px-5 sm:px-8 grid lg:grid-cols-12 gap-10 lg:gap-14">
      <div className="lg:col-span-5">
        <Reveal>
          <Eyebrow>Request Service</Eyebrow>
          <h2 className="mt-5 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-[-0.03em] leading-[0.95] text-white">
            Discuss your <br />property.
          </h2>
          <p className="mt-6 text-base sm:text-lg text-zinc-300 leading-relaxed max-w-md">
            Send a work order, request an assessment, or start a multi-year operations partnership.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-10 divide-y divide-white/10 border-y border-white/10">
            {INFO.map(({ icon: I, label, value, href, id }) => {
              const Tag = href ? "a" : "div";
              return (
                <Tag key={label} href={href} data-testid={id} className="flex gap-4 py-5 group">
                  <I className="h-5 w-5 text-[#FF6B00] mt-0.5 shrink-0" />
                  <div>
                    <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-400">{label}</p>
                    <p className="mt-1 text-white font-medium whitespace-pre-line group-hover:text-[#FF6B00] transition-colors">{value}</p>
                  </div>
                </Tag>
              );
            })}
          </div>
          <a href={PHONE_HREF} data-testid="contact-emergency" className="mt-6 flex items-center gap-3 rounded-[6px] bg-[#FF6B00] text-[#0B0C10] px-5 py-4 font-semibold hover:bg-[#FF7A00] transition-colors">
            <Siren className="h-5 w-5" /> Emergency dispatch available — call {PHONE}
          </a>
        </Reveal>
      </div>
      <Reveal delay={0.15} className="lg:col-span-7">
        <div className="rounded-[6px] bg-white text-[#0B0C10] p-6 sm:p-10 min-h-[520px] flex flex-col">
          <div className="flex items-center justify-between gap-4 pb-6 border-b border-zinc-200">
            <div>
              <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-[#C2410C]">Work Order Request</p>
              <h3 className="mt-1 font-display font-bold text-2xl">Request Service</h3>
            </div>
            <span className="font-mono text-[11px] uppercase tracking-[0.14em] text-zinc-600 border border-zinc-200 rounded-full px-3 py-1">Powered by Jobber</span>
          </div>
          {/* Paste the Jobber request form embed code inside #jobber-form-embed */}
          <div id="jobber-form-embed" data-testid="jobber-form-embed" className="flex-1 mt-6 rounded-[4px] border-2 border-dashed border-zinc-300 bg-zinc-50 grid place-items-center text-center p-8">
            <div>
              <FileUp className="h-8 w-8 text-[#FF6B00] mx-auto" />
              <p className="mt-4 font-display font-semibold text-lg">Jobber request form loads here</p>
              <p className="mt-2 text-sm text-zinc-600 max-w-sm">
                Name, email, phone, property address / corporation #, service needed, details and photo / work-order uploads.
              </p>
              <a href={PHONE_HREF} data-testid="jobber-fallback-call" className="btn-primary mt-6">
                <Phone className="h-4 w-4" /> Call {PHONE}
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
